import { qs, qsa, listen } from "@fluorescent/dom";

import { section } from "@/glow";
import dispatchCustomEvent from "@/lib/dispatch-custom-event";

import { animateSlideshow, shouldAnimate } from "@/lib/animation";

const selectors = {
  slide: ".slideshow-slide",
  textContent: ".text-container:not(.text-box) .text-container-inner > *",
  textBox: ".text-container.text-box",
  navigationContainer: ".slideshow-navigation",
  pauseButton: ".slideshow-navigation__pause-button",
};

section("slideshow", {
  onLoad() {
    const { scrollerId } = this.container.dataset;

    this.scrollerId = scrollerId;
    this.slides = qsa(selectors.slide, this.container);
    this.scrollerInitialized = false;
    this.events = [];

    document.addEventListener(
      `scroll-slider-${this.scrollerId}:initialized`,
      () => {
        this.scrollerInitialized = true;
      },
      { once: true }
    );

    if (shouldAnimate(this.container)) {
      this.animateSlideshow = animateSlideshow(this.container, this.slides);
    }

    this.navigationContainer = qs(
      selectors.navigationContainer,
      this.container
    );

    if (this.navigationContainer) {
      this.pauseButton = qs(selectors.pauseButton, this.navigationContainer);

      if (this.pauseButton) {
        this.events.push(
          listen(this.pauseButton, "click", () => {
            if (this.pauseButton.dataset.isPlaying === "true") {
              this.pauseAutoPlay();
            } else {
              this.resumeAutoPlay();
            }
          })
        );
      }
    }
  },

  pauseAutoPlay() {
    dispatchCustomEvent(`scroll-slider-${this.scrollerId}:pause`);
    this.pauseButton.dataset.isPlaying = "false";
    this.pauseButton.setAttribute(
      "aria-label",
      this.pauseButton.dataset.playLabel
    );
  },

  resumeAutoPlay() {
    dispatchCustomEvent(`scroll-slider-${this.scrollerId}:play`);
    this.pauseButton.dataset.isPlaying = "true";
    this.pauseButton.setAttribute(
      "aria-label",
      this.pauseButton.dataset.pauseLabel
    );
  },

  handleBlockSelect(index, behavior) {
    if (this.pauseButton) {
      this.pauseAutoPlay();
    }

    dispatchCustomEvent(`scroll-slider-${this.scrollerId}:go-to-slide`, {
      slideIndex: index,
      behavior,
    });
  },

  onBlockSelect({ target: slide }) {
    const index = parseInt(slide.dataset.index, 10);

    // When the editor flushes the section on block select
    // we need to wait for the scroll-slider to initialize
    // before we can scroll to the selected slide. The editor
    // will flush section content on setting update, but will
    // not on selecting the block itself.
    if (this.scrollerInitialized) {
      this.handleBlockSelect(index, "instant");
    } else {
      document.addEventListener(
        `scroll-slider-${this.scrollerId}:initialized`,
        () => {
          this.handleBlockSelect(index, "instant");
        },
        { once: true }
      );
    }
  },

  onBlockDeselect() {
    dispatchCustomEvent(`scroll-slider-${this.scrollerId}:play`);
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
    this.animateSlideshow?.destroy();
  },
});
